
export type ValidationResult = {
  isValid: boolean;
  errors: { [key: string]: string };
};

export function validateForm(
  data: { [key: string]: any },
  requiredFields: string[]
): ValidationResult {
  const errors: { [key: string]: string } = {};

  requiredFields.forEach((field) => {
    if (
      data[field] === undefined ||
      data[field] === null ||
      (typeof data[field] === "string" && data[field].trim() === "")
    ) {
      errors[field] = `${field} is required.`;
    }
  });

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
}
